<template>
  <div class="free-audio-player-component"
  >
    <div class="icon-container"
         @click.stop="handleClickIcon"
    >
      <ym-loading v-if="loading"
                  class="player-spinner"
                  type="fading-circle"
                  :size="10"
      />
      <ym-icon v-else
                :name="icon"
      />
    </div>
    <div class="program-desc"
         @click="handleClickDesc"
    >
      <span class="player-title ym-line-ellipsis">{{ item.title }}</span>
      <span class="player-duration">{{ item.duration }}</span>
    </div>
  </div>
</template>

<script>
  import { Loading } from '@ymba/ym-ui';

  export default {
    name: 'FreeListAudioPlayer',
    components: {
      'ym-loading': Loading,
    },
    data() {
      return {
        disabled: false,
      };
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      playing: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    computed: {
      icon() {
        return this.playing ? 'round-pause' : 'round-play';
      },
      canPlay() {
        return (this.item.trialLength === -1) || (this.item.isMember || this.item.isVipMember);
      },
    },
    methods: {
      handleClickIcon() {
        if (!this.canPlay) {
          this.$toast('请先订阅课程');
          return;
        }
        this.$emit('click-icon', this.item);
      },
      handleClickDesc() {
        this.$emit('click-desc', this.item);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .free-audio-player-component {
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  @icon-size: 40px;
  .icon-container {
    width: @icon-size;
    height: @icon-size;
    overflow: hidden;
    line-height: 1;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: @size-extra-small + @size-extra-small / 2;
    color: @color-text-primary;
    background: @color-white;
    font-size: @icon-size;
  }

  @spinner-size: 32px;
  .player-spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    height: @spinner-size;
    width: @spinner-size;
    border-radius: @border-radius-round;
    border: @border-primary;
  }

  .program-desc {
    flex: 1;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    font-weight: @font-weight-strong;
  }

  .player-title {
    flex: 1;
    font-size: @font-size-base;
    color: @color-text-base;
    line-height: 1.2;
  }

  .player-duration {
    flex-shrink: 0;
    white-space: nowrap;
    color: @color-text-lighter;
    font-size: @font-size-extra-small;
    line-height: 1.2;
    margin-left: @size-small;
  }
</style>
